class Events {
  static SIGN_UP = 'signup';
  static LOGIN = 'login';
  static LOG_OUT = 'logout';
  static CLICK_DELETE_ACCOUNT = 'click_delete_account';
  static DELETE_ACCOUNT = 'delete_account';
  static SETTINGS_UPDATE = 'settings_update';
  static PROJECT_CREATE = 'project_create';
  static PROJECT_ARCHIVE = 'project_archive';
  static PROJECT_REACTIVATE = 'project_reactivate';
  static PROJECT_DELETE = 'project_delete';
  static PROJECT_UPDATE = 'project_update';
  static PROJECT_VIEW = 'project_view';
  static CLICK_LOG_TODAY = 'click_log_today';
  static CLICK_LOG_HISTORY = 'click_log_history';
  static PROJECT_LOG = 'project_log';
  static CLICK_HISTORY_DATE = 'click_history_date';
  static CLICK_HISTORY_MONTH = 'click_history_month';
  static EXPORT_TODAY = 'export_today';
  static EXPORT_HISTORY = 'export_history';
  static EXPORT_PROJECT = 'export_project';
  static START_TIMER = 'timer_start';
  static STOP_TIMER = 'timer_stop';
  static DISCARD_TIMER = 'timer_discard';
}

export default Events;



// WEBPACK FOOTER //
// ./src/analytics/Events.js